import React, { useState,useContext } from 'react'
import { webDevelopment, digitalMarketing, wordpressCms, editingSkills } from '../data/skills';
import Tilt from 'react-parallax-tilt';
import { motion } from 'framer-motion';
import {themeContext} from '../context/Theme'
import { useTranslation } from 'react-i18next';
import withScrollReveal from '../animattion/withScrollReveal';


const Skills = () => {

  const [tab, setTab] = useState('Web_Development');
  const [active, setActive] = useState(1);
  const {dark} = useContext(themeContext);
  const {t} = useTranslation();
  function handleTabChange(e) {
    setTab("");
    const val = e.target.value;
    setTab(val);
  };

  return (
    <div id='Skills' className='h-auto w-auto md:pt-10'>
      <p className='text-center text-[2rem] font-bold'>{t('Skills')}</p>
      <div className="py-6 flex flex-col">
        {/* dropdown for mobile */}
        <div className={`flex flex-col justify-center  border-transparent md:hidden `}>

          <label htmlFor="dropDown" className={`mx-auto font-bold`}>Select Option</label>

          <div className={`mx-auto my-4 ${dark ? 'text-black focus:text-black ':' text-black border-2 border-black'}`}>
            <select name="dropDown" defaultValue='Web_Development' id="dropDown" className='w-auto focus:outline-none' onChange={handleTabChange}>
              <option value="Web_Development" >Web Development</option>
              <option value="Marketing" >Marketing</option>
              <option value="Wordpress" >Wordpress</option>
              <option value="Editing">Editing</option>
            </select>
          </div>

        </div>
        {/* tabs for desktop*/}
        <div className='hidden md:block md:pb-4 mx-auto'>
          <button className={`px-4 py-2 border-2 ${active === 1 ? 'bg-blue text-white' : dark ? 'bg-dark_gray':'bg-gray-200' }`} 
          onClick={() => {
            setTab("Web_Development");
            setActive(1);
          }}>Web Development</button>
          <button className={`px-4 py-2 border-2 border-l-0 ${active === 2 ? 'bg-blue text-white' : dark ? 'bg-dark_gray ':'bg-gray-200 ' }`} 
          onClick={() => {
            setTab("Marketing");
            setActive(2);
          }}>Marketing</button>
          <button className={`px-4 py-2 border-2 border-l-0 ${active === 3 ? 'bg-blue text-white' : dark ? 'bg-dark_gray':'bg-gray-200' }`} 
          onClick={() => {
            setTab("Wordpress");
            setActive(3);
          }}>Wordpress</button>
          <button className={`px-4 py-2 border-2 border-l-0 ${active === 4 ? 'bg-blue text-white' : dark ? 'bg-dark_gray':'bg-gray-200' }`}
          onClick={() => {
            setTab("Editing");
            setActive(4);
          }}>Editing</button>
        </div>
        {/* symbols */}
        <Tilt className={`flex flex-wrap justify-center items-center p-4 gap-4 hover:shadow-2xl hover:shadow-blue z-10 ${dark ? 'bg-dark_gray ' : 'bg-gray-200 hover:shadow-black'}`}>
          {
            tab === 'Web_Development' ?
              webDevelopment.map((webData) => (
                <span key={webData.id} className='flex flex-col p-1 items-center'>
                  <motion.img src={webData.icon} title={webData.desc} loading='eager'
                  alt={webData.desc}  whileHover={{ scale: 1.2 }} className='h-[3rem]' />
                  <p className='text-center text-md'>{webData.desc}</p>
                </span>
              )) :

              tab === 'Marketing' ?
                digitalMarketing.map((marketingData) => (
                  <span key={marketingData.id} className='flex flex-col p-1 items-center'>
                    <motion.img src={marketingData.icon} alt={marketingData.desc}  loading='eager' whileHover={{ scale: 1.2 }} className='h-[3rem]' />
                    <p className='text-center text-md'>{marketingData.desc}</p>
                  </span>
                )) : 

                tab === 'Wordpress' ?
                wordpressCms.map((wordpressData) => (
                  <span key={wordpressData.id} className='flex flex-col p-1 '>
                    <motion.img src={wordpressData.icon} alt={wordpressData.desc}  loading='eager' whileHover={{ scale: 1.2 }} className='h-[3rem] mx-auto' />
                    <p className='text-center text-md'>{wordpressData.desc}</p>
                  </span>
                )) :

                tab === 'Editing' ?
                editingSkills.map((editingData) => (
                  <span key={editingData.id} className='flex flex-col p-1 '>
                    <motion.img src={editingData.icon} alt={editingData.desc} loading='eager' whileHover={{ scale: 1.2 }} className='h-[3rem] mx-auto' />
                    <p className='text-center text-md'>{editingData.desc}</p>
                  </span>
                )) : ""

          }
        </Tilt>
      </div>

    </div>
  )
}

export default withScrollReveal(Skills);